import { jsx as _jsx } from "react/jsx-runtime";
import graphqlClientFactory from 'lib/graphql-client-factory';
import ArticleCategoryTabsQuery from 'components/authorable/shared/page-specific/ArticleCategoryTabs.graphql';
import ArticleCategoryTabsClient from './ArticleCategoryTabsClient';
export const Default = (props)=>/*#__PURE__*/ _jsx(ArticleCategoryTabsClient, {
        ...props
    });
